import { useRoles } from '@zorro/web/ui-utils';

import { EnrollmentStatusViewer } from './EnrollmentStatusUtils';

export function useEnrollmentStatusViewer(
  isEmployeeView?: boolean
): EnrollmentStatusViewer {
  const { isAgent, isAccountSupervisor, isZorroOperations } = useRoles();

  if (isEmployeeView) {
    return 'employee';
  }

  return isAgent || isAccountSupervisor || isZorroOperations
    ? 'ops'
    : 'employerAdmin';
}
